import api from '@/api'

export default {
  all: (filter) => api('get', '/group', filter),
  create: (data) => api('post', '/group', data),
  show: (id) => api('get', `/group/${id}`),
  delete: (id) => api('delete', `/group/${id}`),
  update: (data) => api('put', `/group/${data.id}`, data)
}
